import {PollRobotTemplate} from './PollRobotTemplate.js';

class TableColumn {
	constructor(fld, title) {
		this.fld = fld;
		this.title=title;
	}
}
class TableModel {
	constructor() {
		this.columns=[];
		this.columnDict={};
		this.rows= [];
	}
	addColumn(fld,title=false) {
		if (!title) title=fld;
		if (!this.columnDict[fld]) {
			const tc = new TableColumn(fld,title);
			this.columns.push(tc);
			this.columnDict[fld] = tc;
		}
	}
	addRow(row) {
		this.rows.push(row);
		// if (null==userDetail) {
		// 	this.rows.push(null);
		// 	return;	
		// }
		// // Object.keys(userDetail).forEach( (k,_)=>this.addColumn(k,k));
		// this.rows.push(obj);
	}
	renderHeader(head) {
		head.innerHTML = ``;
		const tr = document.createElement(`tr`);
		for (const c of this.columns) {
			const th = document.createElement(`th`);
			th.innerText = c.title;
			tr.appendChild(th);
		}
		head.appendChild(tr);
	}
	renderBody(body) {
		body.innerHTML = ``;
		// for (let i=0; i<1000; i++) {
		for (const r of this.rows) {
			const tr = document.createElement(`tr`);
			if (r) {
				for (const c of this.columns) {
					const td = document.createElement(`td`);
					td.innerText = r[c.fld] ?? '';
					tr.appendChild(td);
				}
			}
			body.appendChild(tr);
		}
		// }
	}
	renderTable(head, body) {
		this.renderHeader(head);
		this.renderBody(body);
	}
}

function convertUserDetailAndAnswersToDict(user, answers, poll, tableModel) {
	// answers is map[uint]AnyAnswer
	const dict={};
	if (user != null){
		Object.keys(user).forEach( (k,_)=>{
			dict[k] = user[k];
			tableModel.addColumn(k,k);
		});
	}else{
		dict["name"] = null;
	}
	poll.Questions.forEach( (q)=>{
		const k = `q${q.ID}`;
		const qa = answers[q.ID];
		console.log(`Answer for question ${q.ID}:`, qa);
		if (qa) {
			if (qa.Options) {
				// qa is an Answer, and can have an array of Options, which is []uint
				qa.Options.forEach( oid => {
					console.log(`Setting Option ${k}.${oid} to Y`);
					dict[`${k}.${oid}`] = 'Y';
				});
			} else {
				console.log(`qa.Options NOT FOUND`);
			}
			if (qa.Text) {
				dict[k] = qa.Text;
			}
		}
	});
	console.log(`answers `, answers, ` mapped to `, dict);
	return dict;
}

function addQuestionsToTableModel(poll, tableModel) {
	poll.Questions.forEach(q => {
		if (q.Options) {
			q.Options.forEach( o => tableModel.addColumn(`q${q.ID}.${o.ID}`,o.Option));
		} else {
			tableModel.AddColumn(`q${q.ID}`, q.Question);
		}
	});
}

export class UserDetailTable extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = PollRobotTemplate(`UserDetailTable`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);
		// this.addEventListener(`load-table`, evt=>this.loadTable(evt.detail));
		this.$.close.addEventListener(`click`, evt=>{
			this.$.dialog.close();
		});
	}
	connectedCallback() {

	}
	loadTable(tableUrl) {
		fetch(tableUrl).then(js => js.json() )
		.then(
			res=>{
				console.log(`fetch of ${tableUrl} returned `, res);
				const model = new TableModel();
				const rows = res.Answers.map( a => convertUserDetailAndAnswersToDict(a.UserDetail, a.Answers, res.Poll, model));
				addQuestionsToTableModel(res.Poll, model);
				let missing = [];
				rows.forEach(r => {
					if (r != null) {
						model.addRow(r)
					} else {
						missing.push(r.answer_id);
					}
				});
				console.log(missing);
				console.log(missing.length);
				model.renderTable(this.$.head, this.$.body);
				this.$.dialog.showModal();
			})
		.catch(err => console.error(err));
	}
}

customElements.define(`pollrobot-userdetailtable`, UserDetailTable);